<template>
    <div v-if="tableData" style="width: 100%;">
        <table class="table table-bordered text-center align-middle">
            <colgroup>
                <col style="width: 35%;" />
                <col style="width: 30%;" />
                <col style="width: 35%;" />
            </colgroup>
            <thead>
                <tr>
                    <th class="gray">{{ timeDsvn == "YEAR" ? "작년 (증감)" : "전월 (증감)" }}</th>
                    <th class="blue">{{ timeDsvn == "YEAR" ? "올해" : "당월" }}</th>
                    <th class="gray">{{ timeDsvn == "YEAR" ? "재작년 (증감)" : "전년 동월 (증감)" }}</th>
                </tr>
            </thead>
            <tbody>
                <tr style="font-weight: bold;">
                    <td>
                        <span>{{ formattedValue.prevMonth }}</span>
                        <span
                            :class="
                                Number(formattedValue.prevDiff.value) > 0
                                    ? 'text-blue'
                                    : Number(formattedValue.prevDiff.value) < 0
                                    ? 'text-danger'
                                    : ''
                            "
                        >
                            {{
                                ` (${Number(formattedValue.prevDiff.value) > 0 ? "+" : ""}${
                                    formattedValue.prevDiff.text
                                })`
                            }}
                        </span>
                    </td>
                    <td>
                        <span>{{ formattedValue.currentMonth }}</span>
                    </td>
                    <td>
                        <span>{{ formattedValue.lastYearSameMonth }}</span>
                        <span
                            :class="
                                Number(formattedValue.lastYearDiff.value) > 0
                                    ? 'text-blue'
                                    : Number(formattedValue.lastYearDiff.value) < 0
                                    ? 'text-danger'
                                    : ''
                            "
                        >
                            {{
                                ` (${Number(formattedValue.lastYearDiff.value) > 0 ? "+" : ""}${
                                    formattedValue.lastYearDiff.text
                                })`
                            }}
                        </span>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Object,
            default: () => {},
        },
        timeDsvn: {
            type: String,
            default: "",
        },
    },
    components: {},
    data() {
        return {};
    },
    computed: {
        formattedValue() {
            let values;
            const tableData = this.tableData;

            function _toStr(value) {
                if (!value) return 0;
                if (typeof value === "number") {
                    const formatted = Number.isInteger(value) ? value : Number(value.toFixed(1));
                    return formatted.toLocaleString();
                } else {
                    const formatted = Number.isInteger(Number(value))
                        ? Number(value)
                        : Number(Number(value).toFixed(1));
                    return formatted.toLocaleString();
                }
            }

            function _calcDiff(current, previous) {
                const numCurrent = current ? Number(current) : 0;
                const numPrevious = previous ? Number(previous) : 0;
                const diff = numPrevious - numCurrent;
                return { value: diff, text: Number(diff.toFixed(1)).toLocaleString() };
            }

            if (this.timeDsvn == "MONTH") {
                values = {
                    prevMonth: _toStr(tableData.prevMonth ?? 0),
                    prevDiff: _calcDiff(tableData.currentMonth ?? 0, tableData.prevMonth ?? 0),
                    currentMonth: _toStr(tableData.currentMonth ?? 0),
                    lastYearSameMonth: _toStr(tableData.prevYearMonth ?? 0),
                    lastYearDiff: _calcDiff(tableData.currentMonth ?? 0, tableData.prevYearMonth ?? 0),
                };
            } else {
                values = {
                    prevMonth: _toStr(tableData.prevYear ?? 0),
                    prevDiff: _calcDiff(tableData.currentYear ?? 0, tableData.prevYear ?? 0),
                    currentMonth: _toStr(tableData.currentYear ?? 0),
                    lastYearSameMonth: _toStr(tableData.prevPrevYear ?? 0),
                    lastYearDiff: _calcDiff(tableData.currentYear ?? 0, tableData.prevPrevYear ?? 0),
                };
            }

            return values;
        },
    },
    watch: {},
    mounted() {},
    created() {},
    methods: {},
};
</script>

<style scoped>
/* table  */
.gray {
    background-color: #444;
    color: #fff;
}
.blue {
    background-color: #003366;
    color: #fff;
}

/* 증감률 값 표현할때 사용 예정 */
.increase {
    color: #ff4d4f;
}
.decrease {
    color: #4da6ff;
}
</style>
